import { render, staticRenderFns } from "./tiscTable.vue?vue&type=template&id=646ac748&scoped=true&"
import script from "./tiscTable.vue?vue&type=script&lang=js&"
export * from "./tiscTable.vue?vue&type=script&lang=js&"
import style0 from "./tiscTable.vue?vue&type=style&index=0&id=646ac748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ac748",
  null
  
)

export default component.exports